
  import {Component, Vue} from "vue-property-decorator";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import Scan from "@/views/components/Scan/Scan2.vue";
  import config from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  import TableHeader from "./TableHeader.vue";
  import dayjs from "dayjs";
  import {LogHelper} from "@/common/LogHelper";

  import {
     checkCodesAndType, cloudPress, backFLowOperationCountUpload,
  } from "@/api/service";
  import {ApiQueryType, ModeType, ReceiveDataType, SendDataType} from "@/common/glboalconstant";
  import {
    playFailSound,
    NoticeVoiceInit,
  } from "@/common/voiceTip";
  import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
  import {DeviceItems2Module} from "@/store/modules/store_deviceitems2";
  import { SystemConfigModule } from "@/store/modules/store_systemconfig";

  @Component({
    name: "scanforbackflow",
    components: {
      DeviceItems2,
      YtoTable,
      Form1,
      Form2,
      TableHeader,
      Scan,
    },
  })
  export default class extends Vue {
    public inputModel: inputDataModel_BackFlow = {
      input_ScanCode: "",
      input_latticeNo: "",
      circleLine: 0,
      maxLatticeNo: 0,
      deviceAttribute: 0,
    };
    public globalConfig: any = {};
    public loginData: any = {};
    public index = 1;
    public totalScanCount = "0";
    public config = config;
    public currentrow = null;
    public showList = [];
    public ytoCode = "";
    public deviceItems: deviceItem[] = [];
    public errormessage = "";
    public datahistory = [];
    public callbackmodel = {};
    public nTotalScanNum = 0;
    private timer;
    private uploading = false;
    public DataQueue = [];
    private m_bFirstGet = true;

    mounted() {
      try {
        NoticeVoiceInit();
        this.globalConfig = SystemConfigModule.globalData;
        this.loginData = SystemConfigModule.loginData;
      } catch (error) {
        LogHelper.WriteLog("回流扫描界面:初始化异常" + error);
      }

      //注册相机回调条码事件
      if (typeof obj_CodeReader_Core !== "undefined") {
        obj_CodeReader_Core.registerJavaScriptCallback(
          "CodeReaderSetPackageData",
          (value) => {
            LogHelper.WriteLog(
              dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "得到快手条码:" + value
            );
            debugger;
            // if (this.inputModel.input_latticeNo == "" && !this.inputModel.check_macrocycle) {
            //   this.errormessage = "请输入下层线格口号";
            //   return;
            // }
            let data = JSON.parse(value);
           //条码校验
            let temps = [];
            temps.push(data.CodeInfo);
            var rgStr = checkCodesAndType(
              temps,
              "334"
            );
            var rg = JSON.parse(rgStr);
            let expType = "";
            if (rg.Type == ApiQueryType.strPackageCode) {
              expType = "20";
            } else if (rg.Type == ApiQueryType.strWayBillCode) {
              expType = "10";
            } else {
              this.errormessage = "";
              return;
            }
            let index = this.InsertDataToList(data.CodeInfo, "未上传", "");
            this.clearData();
            //异步上传数据
            this.DataQueue.unshift({
              wayBillNo: data.CodeInfo,
              createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
              latticeNo: this.inputModel.input_latticeNo,
              operationType: "NEW",
              expType: expType,
              index: index
            });
          }
        );
        console.log('CodeReaderSetPackageData注册成功');
      }

      console.log('loaded')
      if (typeof obj_ScanForBackFlow !== "undefined")
      {
        obj_ScanForBackFlow.vueLoaded();
      }

      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
      this.timer = setInterval(() => {
        if (this.DataQueue.length) {
          if (this.uploading) {
            return;
          } else {
            try {
              this.uploading = true;
              this.BackFlowDataUploadNew();
            } catch (error) {
              console.log("error");
              console.log(error);
            } finally {
              this.uploading = false;
            }
          }
        }
      }, 300);

      debugger;
      if (typeof obj_DWS_Core !== "undefined")
      {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            console.log("DWS传输过来的参数");
            console.log(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
    }
    // 销毁组件前清除定时器
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }

      //获取参数
    private getFormValue(element) {
      this.inputModel = element;
    }
    //DWS数据处理
    private ReceiveDataEvent(receiveDataEventArgs) {
      switch (receiveDataEventArgs.ReceiveDataType) {
        case ReceiveDataType.CameraState:
          LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
          this.SetCameraState(
            JSON.parse(receiveDataEventArgs.JsonData.toString())
          );
          break;
        case ReceiveDataType.PackageData:
          LogHelper.WriteLog("收到底层数据:" + receiveDataEventArgs.JsonData);
          break;
        case ReceiveDataType.CodeCheck:
          LogHelper.WriteLog("收到底层数据，暂无逻辑处理:" + receiveDataEventArgs.JsonData);
          // if (this.inputModel.input_latticeNo == "" && !this.inputModel.check_macrocycle) {
          //   this.errormessage = "请输入下层线格口号";
          //   return;
          // }
          break;
        case ReceiveDataType.ErrorState:
          LogHelper.WriteLog(
            "收到底层错误状态码:" + receiveDataEventArgs.JsonData
          );
          break;
        case ReceiveDataType.ErrorInfo:
          LogHelper.WriteLog("收到底层错误信息:" + receiveDataEventArgs.JsonData);
          break;
      }
    }

    //DWS设置相机状态
    private SetCameraState(strCameraState) {
      let items = this.RefreshState(strCameraState);
      DeviceItems2Module.SetDeviceItemsState(items);

      if (this.m_bFirstGet) {
        this.m_bFirstGet = false;
        //等待200ms后尝试执行
        setTimeout(() => {
          obj_DWS_Core.hKSocketSynSendDataCallBack(
            SendDataType.Watermark,
            this.loginData.orgCode + "|" + this.loginData.orgName + "|335|回流"
          );
          LogHelper.WriteLog(
            "SendDataType.Watermark:" +
            this.loginData.orgCode +
            "|" +
            this.loginData.orgName +
            "|335|回流"
          );
        }, 0.2 * 1000);
      }

      return;
    }

    //DWS刷新设备状态信息
    private RefreshState(camera_State) {
      let result = [];
      for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
        let _info =
          "" +
          "设备" +
          i.toString() +
          "-" +
          "设备状态:" +
          camera_State.cameraState.camList[i - 1].camStatus +
          "-" +
          "设备模式:" +
          this.IsNullorEmptyorUndefined(
            camera_State.cameraState.camList[i - 1].camModel
          )
            ? ""
            : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

        result.push({
          title: _info,
          name: "设备" + i,
          status:
            camera_State.cameraState.camList[i - 1].camStatus == "1"
              ? "true"
              : "false",
        });
      }

      return result;
    }

    //字符串为null、空、未定义判断
    private IsNullorEmptyorUndefined(data) {
      if (data == null || data == undefined || data == "") {
        return true;
      } else {
        return false;
      }
    }
      //表格选择动作
    private currentRowChanged(element) {
      this.currentrow = element;
      this.callbackmodel = this.inputModel;
    }

    //删除按钮
    private deletedatahistory() {
      if (this.currentrow === null) {
        this.$message.warning("请先选择要删除的行");
        return;
      }
      this.$confirm("是否确定要删除此数据？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          try {
            //异步上传数据
            this.DataQueue.unshift({
              wayBillNo: this.currentrow.wayBillNo,
              createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
              latticeNo: this.inputModel.input_latticeNo,
              operationType: "DELETE",
              expType: 10,
              index: this.currentrow.index
            });

          } catch (error) {
            LogHelper.WriteLog("删除失败：" + error.message);
          }
        })
        .catch(() => {
          LogHelper.WriteLog("取消删除");
        });
    }

    //清除参数
    private clearData() {
      this.ytoCode = "";
    }

    //扫描区扫码
    private ytocodeget() {
      try {
        debugger;
        var scanAreaContent = this.ytoCode.toUpperCase().toUpperCase().trim();
        if (scanAreaContent == "") {
          try {
            playFailSound();
            this.errormessage = "输入为空";
            return;
          } catch (Exception) {
            this.errormessage = "输入为空,警告提示音不存在";
            return;
          }
        }
        var reg1 = new RegExp(/^[A-Za-z0-9]+$/);
        if (!reg1.test(scanAreaContent)) {
          this.errormessage = "输入数据非法，只能输入数字和字母";
          return;
        }
        this.errormessage = "";
        //条码校验
        let temps = [];
        temps.push(scanAreaContent);
        var rgStr = checkCodesAndType(
          temps,
          "334"
        );
        debugger;
        var rg = JSON.parse(rgStr);
        if (rg.ResultCode != "200") {
          if (rg.Info.length > 32)
          {
            rg.Info = rg.Info.substring(0,32) + "...";
          }
          this.errormessage = rg.Info;
          if (rg.ResultCode != "407") {
            this.$nextTick(() => {
              this.NewAbnormalMovingPartUpload(
                scanAreaContent,
                rg.Info,
                null,
                "100"
              );
            });
          }
          return;
        }

        let expType = "";
        if (rg.Type == ApiQueryType.strPackageCode) {
          expType = "20";
        } else if (rg.Type == ApiQueryType.strWayBillCode) {
          expType = "10";
        } else {
          this.errormessage = "";
          return;
        }
        this.inputModel.input_ScanCode = scanAreaContent;
        if (scanAreaContent.startsWith("R02Z") || scanAreaContent.startsWith("R02T")) {
          scanAreaContent = scanAreaContent.replace("R02T", "").replace("R02Z", "")
        }

        let index = this.InsertDataToList(scanAreaContent, "未上传", "");
        //异步上传数据
        this.DataQueue.unshift({
          wayBillNo: scanAreaContent,
          createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
          latticeNo: this.inputModel.input_latticeNo,
          operationType: "NEW",
          expType: expType,
          index: index
        });
      } catch (error) {
        LogHelper.WriteLog(error.message);
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    //插入表格
    private InsertDataToList(strcode, stateMsg, tips) {
      debugger;
      let datetime = dayjs();
      var data: any = {
        wayBillNo: strcode,
        strScanTime: datetime.format("YYYY-MM-DD HH:mm:ss"),
        latticeNo: this.inputModel.input_latticeNo,
        state: stateMsg,
        strTip: tips,
        index: this.index,
      };
      this.index++;
      this.showList.unshift(data);
      while (this.showList.length > 50) {
        this.showList.pop();
      }
      this.nTotalScanNum++;
      this.totalScanCount = this.nTotalScanNum.toString();
      return this.index;
    }

    //更新表格数据
    public UpdateListData(index, wayBillNo, result, tips) {
      try {
        for (var i = 0; i < this.showList.length; i++) {
          debugger;
          if (this.showList[i].index == (index - 1) && this.showList[i].wayBillNo == wayBillNo && this.showList[i].state == "未上传") {
            this.showList[i].state = result;
            this.showList[i].strTip = tips;
            break;
          }
        }
      } catch (e) {

      }
    }

    //回流扫描上传
    public BackFlowDataUpload(strCode, opType, codeType, row) {
      try {
        let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
        let tips = "";
        let stateMsg = "未上传";
        let signsure = obj_HttpRequest_Core.getSignature("8607", datetimeNow);
        let _request = {
          mty: "8607",
          signature: signsure,//登录时需要获取的签名
          createTime: datetimeNow,
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          createOrgCode: this.loginData.orgCode,
          createOrgName: this.loginData.orgName,
          channel: "CV-PC",
          deviceNo: this.globalConfig.LocalMac,//大写,用冒号分隔，必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          waybillNo: strCode,
          auxOpCode: opType,
          expType: codeType
        };
        let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
        let bRet = false;
        if (stReturnStr?.code == "000") {
          LogHelper.WriteLog("回流扫描上传成功");
          stateMsg = "上传成功";
          bRet = true;
        } else {
          //上传失败
          tips = stReturnStr?.msg;
          stateMsg = "上传失败";
          bRet = false;
        }
        debugger;
        //插入列表
        if (opType == "NEW") {
          this.InsertDataToList(strCode, stateMsg, tips);
          this.nTotalScanNum++;
          this.totalScanCount = this.nTotalScanNum.toString();
        } else {
          if (bRet) {
            if (this.showList.length > 0) {
              let _showlist = this.showList;
              var _data = _showlist.filter(
                (item) =>
                  !(
                    item.index == row &&
                    item.strCarCode == strCode
                  )
              );
              this.showList = _data;
            }
            this.clearData();
            this.errormessage = "删除成功！";
            if (this.nTotalScanNum > 0) this.nTotalScanNum--;
            this.totalScanCount = this.nTotalScanNum.toString();
            LogHelper.WriteLog(
              "ScanForBackFlow_Delete:" + "Barcode " + strCode + " is Deleted"
            );
            return 0;
          } else {
            this.errormessage = "删除失败";
          }
        }
      } catch (e) {
      }
    }

    //异步回流扫描接口
    public BackFlowDataUploadNew() {
      try {
        if (this.DataQueue.length > 0) {
          let data = this.DataQueue.pop();
          debugger;
          let tips = "";
          let signsure = obj_HttpRequest_Core.getSignature("8607", data.createTime);
          var _latticeno :String = "";
          if (this.inputModel.deviceAttribute == 2) {
            _latticeno = this.inputModel.input_latticeNo;
          }
          let _request = {
            mty: "8607",
            signature: signsure,//登录时需要获取的签名
            createTime: data.createTime,
            createUserCode: this.loginData.userCode,
            createUserName: this.loginData.userName,
            createOrgCode: this.loginData.orgCode,
            createOrgName: this.loginData.orgName,
            channel: "CV-PC",
            deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
            deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
            waybillNo: data.wayBillNo,
            auxOpCode: data.operationType,
            expType: data.expType,
            latticeNo: _latticeno
          };

          let _Id = dayjs().valueOf().toString();

          //上传数据插入本地Sqlite，add by klm 2023-01-12
          try{
              if (data.operationType == "NEW" && (typeof obj_ScanForBackFlow !== "undefined"))
              {
                obj_LocalData_Core.insertExpWayBillCheck({
                  CreateTime: data.createTime,
                  ExecuteSubject: 0,
                  Id: _Id,
                  ModifyTime: data.createTime,
                  Request: JSON.stringify(_request),
                  WaybillNo: data.wayBillNo,
                  Response: "",
                  Status: 0, //操作数据上传标识位，0表示为上传，1表示上传成功，2表示上传失败，3表示重复上传
                  OpCode: 334,
                  DeviceType: this.globalConfig.CurrentDeviceType.toString(),
                  protocolType: 0,
                  EXTEND1: "0", //操作量上传标识位，0表示未上传，1表示上传成功，2表示上传失败
                  EXTEND2:this.inputModel.circleLine,//矩阵循环线,
                  EXTEND3:"",
                  EXTEND4: "",
                  EXTEND5: "",
                  EXTEND6: "",
                });
              }
            //*********************************/
          }
          catch (e) {
            console.log("回流扫描620" + e);
          }

          let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));

          if ("DELETE" == data.operationType) {
            if (stReturnStr?.code == "000") {
              //删除成功
              if (this.showList.length > 0) {
                let _showlist = this.showList;
                var _data = _showlist.filter(
                  (item) =>
                    !(
                      item.index == this.currentrow.index &&
                      item.wayBillNo == this.currentrow.wayBillNo
                    )
                );
                this.showList = _data;
              }
              this.clearData();
              this.errormessage = "删除成功！";
              this.currentrow = null;
              if (this.nTotalScanNum > 0) this.nTotalScanNum--;
              this.totalScanCount = this.nTotalScanNum.toString();
              LogHelper.WriteLog(
                "ScanForBackFlow_Delete:" + "Barcode " + data.wayBillNo + " is Deleted"
              );
            }
            else {
              //删除失败
              this.errormessage = "删除失败";
            }
          }
          else if ("NEW" == data.operationType) {
            let uploadResult = 0;
            if (stReturnStr?.code == "000") {
              uploadResult = 1;
              this.UpdateListData(data.index, data.wayBillNo, "上传成功", stReturnStr?.msg);
              try {
                obj_System_Core.refreshLoaclTime(
                  stReturnStr?.data?.serverTime.toString()
                );
              } catch (error) {
                LogHelper.Error(error);
              }
            } else {
              if (stReturnStr?.code != "-999" && stReturnStr?.respcode != "-999")
              {
                uploadResult = 2;
              }
              //上传失败，更新列表数据
              if(stReturnStr?.respcode == "-999")
              {
                this.UpdateListData(data.index, data.wayBillNo, "上传失败", stReturnStr?.respMessage);
              }
              else
              {
                this.UpdateListData(data.index, data.wayBillNo, "上传失败", stReturnStr?.msg);
              }
            }
            this.clearData();
            //无论上传成功，上传失败都上传操作量
            let uploadOperationCountResult  = this.UpLoadBackFlowOperationCount(data.wayBillNo, data.createTime, data.expType);

            if (typeof obj_ScanForBackFlow !== "undefined")
            {
              //上传成功后更新本地Sqlite内状态
              obj_LocalData_Core.updateExpWayBillCheck(
                {
                  ExecuteSubject: 0,
                  WaybillNo: data.wayBillNo,
                  Id: _Id,
                  ModifyTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
                  Response: JSON.stringify(stReturnStr?.msg),
                  //操作数据状态标志，0表示未上传，1代表上传成功，2代表上传失败，3代表重复扫描
                  Status: uploadResult,
                  DeviceType: this.globalConfig.CurrentDeviceType.toString(),
                },
                uploadOperationCountResult.toString()
              ); //操作量标志，0表示未上传，1代表上传成功，2表示上传失败
            }
          }
        }
      } catch (e) {
        debugger;
      }
    }

    //回流扫描操作量上传
    public UpLoadBackFlowOperationCount(wayBillNo, createTime, expType) {
      try {
        var _latticeno :String = "";
        if (this.inputModel.deviceAttribute == 2) {
          _latticeno = this.inputModel.input_latticeNo;
        }
        let _request: any = {};
        _request.compMac = this.globalConfig.LocalMac;
        _request.compIP = this.globalConfig.LocalIPv4;
        _request.devType = this.globalConfig.CurrentDeviceType.toString();
        _request.userCode = this.loginData.userCode;
        _request.userName = this.loginData.userName;
        _request.opCode = 334;
        _request.waybillNo = wayBillNo;
        _request.containerNo = "";
        _request.orgCode = this.loginData.orgCode;
        _request.orgName = this.loginData.orgName;
        _request.prevOrgCode = "";
        _request.nextOrgCode = "";
        _request.destOrgCode = "";
        _request.sourceOrgCode = "";
        _request.ioType = "";
        _request.expType = (expType == "10") ? 10 : 20;
        _request.optArea = "";
        _request.latticeNo = _latticeno;
        _request.effectiveTypeCode = "";
        _request.volume = "";
        _request.weighWeight = "";
        _request.inputWeight = "";
        _request.optTime = new Date(createTime).valueOf()
        _request.extend1 = "";
        _request.extend2 = this.inputModel.circleLine;//矩阵循环线
        _request.extend3 = "";
        let stReturnStr = JSON.parse(backFLowOperationCountUpload(JSON.stringify(_request)));
        if (stReturnStr?.respcode == "000") {
          console.log("回流扫描操作量上传成功");
          return 1;
        } else {
          console.log("回流扫描操作量上传失败" + stReturnStr?.respMessage);
          if (stReturnStr?.respcode !== "-999")
          {
            return 2;
          }
          else
          {
            return 0;
          }
        }
      } catch (e) {
        debugger;
        console.log("回流扫描操作量上传失败" + e.toString());
        return 0;
      }
    }

    //新异常走件接口，add by klm 20220420
    public NewAbnormalMovingPartUpload(
      strCode,
      strInfo,
      strIoTypeName = null,
      exceptionCode = null) {
      try {
        let ioType = null;
        let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
        let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

        let _request = {
          mty: "8606",
          signature: signsure,//登录时需要获取的签名
          createTime: datetimeNow,
          waybillNo: strCode,
          containerNo: "",//容器号,非必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
          errorCode: exceptionCode,//异常码，必填
          errorMsg: strInfo,//异常信息，必填
          opCode: "334",//操作码，非必填
          ioType: ioType,//收发类型，非必填
          nextOrgCode: "",//下一网点，非必填
          weight: "",//重量，非必填
          createUserCode: this.loginData.userCode,
          extend1: "",
          extend2: "",
          extend3: ""
        };
        let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
        if (stReturnStr?.code == "000") {
          LogHelper.WriteLog("新异常走件方法上传成功");
        } else {
          LogHelper.WriteLog("新异常走件上传失败,返回异常码：" + stReturnStr?.code + "异常信息：" + stReturnStr?.msg);
        }
      } catch (ex) {
        LogHelper.WriteLog("新异常走件接口调用异常" + ex);
      }
    }

    //获取焦点
    private selectElementContents(el) {
      el.blur();
      el.focus();
    }
  }
